function iqxWebBuildClientMenu(menu){
  'use strict';

  menu.addItem({
    id:'iqxWeb_menu_home',
    title:'Home',
    icon:'fas fa-home',
    url:'/home'
  })

  menu.addItem({
    id:'iqxWeb_menu_contactDetails',
    title:'Contact Details',
    icon:'fas fa-pencil-alt',
    url:'/clientcontact'
  })

  menu.addItem({
    id:'iqxWeb_menu_currentRequirements',
    title:'Current Requirements',
    icon:'fas fa-clipboard',
    url:'/currentrequirements',
    rights:'CURRENTREQUIREMENTS'
  })

  menu.addItem({
    id:'iqxWeb_menu_previousTemps',
    title:'Previous Temps',
    icon:'fas fa-users',
    url:'/previous-temps'
  })

  menu.addDropdown({
    id:'iqxWeb_menu_timesheets',
    title:'Timesheets',
    icon:'fas fa-building',
  }).subMenu
    .addItem({
      id:'iqxWeb_menu_current',
      title:'Current',
      url:'/provtimesheets/fill',
      rights:'FILLTIMESHEETS'
    })
    .addItem({
      id:'iqxWeb_menu_authorisation',
      title:'Awaiting Authorisation',
      url:'/provtimesheets/auth',
      rights:'AUTHORISETIMESHEETS'
    })
    .addItem({
      id:'iqxWeb_menu_approval',
      title:'Awaiting Approval',
      url:'/timesheetsapprove',
      rights:'APPROVETIMESHEETS'
    })
    .addItem({
      id:'iqxWeb_menu_completed',
      title:'Completed',
      url:'/timesheets'
    })
  
  menu.addItem({
    id:'iqxWeb_menu_invoices',
    title:'Invoices',
    icon:'fas fa-receipt',
    url:'/clientinvoices',
    rights:'VIEWINVOICES'
  })

  menu.addItem({
    id:'iqxWeb_menu_contacts',
    title:'Contacts',
    icon:'fas fa-address-book',
    url:'/contacts',
    rights:'MAINTAINCONTACTS'
  })

  menu.addItem({
    id:'iqxWeb_menu_reports',
    title:'Reports',
    icon:'fas fa-chart-pie',
    url:'/reports',
    rights:'MANAGEMENTINFO'
  })

  menu.addSplitter({
    id:'iqxWeb_menu_splitter'
  })

  menu.addItem({
    id:'iqxWeb_menu_settings',
    title:'Settings',
    icon:'fas fa-cog',
    url:'/settings'
  })

  menu.addItem({
    id:'iqxWeb_menu_help',
    title:'Help',
    icon:'fas fa-question-circle',
    url:'/help',
    switch:'SHOWFAQPAGE'
  })

  menu.addLogoutButton({
    id:'iqxWeb_menu_logout',
    title:'Logout',
    icon:'fas fa-sign-out-alt',
    click:'logout()',
    switches:'CLIENT_LOGOUT_NAV'
  })

}
